import React, { useState } from "react";
import OpBuySellTag from "../generic/opBuySellTag";
import { EBuyOrSell, IListObj } from "../../../types/genericTypes";
import RadioButton from "../../../generic/radioButton";
import DeviceContext from "../../../service/indentifyDevice";
import InputField from "../../../generic/inputField";
import OpInputNumField from "../generic/opInputNumField";
import OpMandateDropdown from "./../generic/opMandateDropdown";
import OpDropdown from "../generic/opDropdown";
import NavigationTag from "../../../generic/navigationTag";
import OpExplainButton, { IOpTooltip } from "./../generic/opExplainButton";
import OpCalender from "../generic/opCalender";
import OpGenerateMandate, { IOpGenerateMandateProps } from "../opGenerateMandate/opGenerateMandate";
import OpInsufficientFunds from "../opInsufficientFunds/opInsufficientFunds";
import OpOrderStatus from "../opOrderStatus/opOrderStatus";
import OpConfirmation, { IConfirmationContent } from "../opConfirmation/opConfirmation";
import "../../../../assets/scss/components/toc/orderPlacement/sample/opSampleComponents.scss";
import OpTotalPeriod from "../generic/opTotalPeriod";
import indexer from "./../../../types/genericTypes";

export interface IOpSampleComponentsProps {}

const OpSampleComponents: React.FC<IOpSampleComponentsProps> = () => {
	const sampleList: Array<IListObj> = [
		{ value: "lorem ipsum", display: "Lorem ipsum" },
		{ value: "dolor", display: "Dolor" }
	];

	const [selectedRadio, setSelectedRadio] = useState(undefined as string | number | undefined);

	const tagList: Array<IListObj> = [
		{ value: "regular", display: "Regular" },
		{ value: "direct", display: "Direct" }
	];

	const tooltipData: Array<IOpTooltip> = [
		{
			heading: "Regular",
			description: "Lorem Ipsum Dolor Sit Lorem Ipsum Dolor Sit Lorem Ipsum Dolor Sit Lorem Ipsum Dolor Sit Lorem Ipsum Dolor."
		},
		{
			heading: "Direct",
			description: "Lorem Ipsum Dolor Sit Lorem Ipsum Dolor Sit Lorem Ipsum Dolor Sit Lorem Ipsum Dolor Sit Lorem Ipsum Dolor."
		}
	];

	const dummyText = `Lorem ipsum dolor sit, amet consectetur adipisicing elit. Dignissimos
		modi impedit enim, maxime labore, vel sequi corrupti saepe facilis totam tempora! Non quas
		dolorum debitis corrupti quae eligendi suscipit ipsum!`;

	const opGenerateMandateProps: IOpGenerateMandateProps = {
		companyName: "HDFC Balanced Advantage Fund Lorem Ipsum Dolor",
		contentArr: [
			{ label: "SIP Amount", value: "₹ 20,000" },
			{ label: "Start Date", value: "05 Jan 2010" },
			{ label: "Frequency", value: "Monthly" }
		],
		onEdit: onButtonClick
	};

	const contentForConfirmationScreen: Array<IConfirmationContent> = [
		{ field: "Action", value: "SIP" },
		{ field: "Investment Type", value: "Quantity" },
		{ field: "Number of Shares", value: "1" },
		{ field: "Order Type", value: "Market" },
		{ field: "Product Type", value: "NRML" }
	];

	const contentForConfirmationScreen1: Array<IConfirmationContent> = [
		{ field: "Appx. Units", value: "0.5678" },
		{ field: "Total Order Value", value: "₹100" },
		{ field: "SIP Type", value: "Perpectual" },
		{ field: "Frequency", value: "Monthly" },
		{ field: "Duration", value: "Until Cancelled" }
	];

	const contentForConfirmationScreen2: Array<IConfirmationContent> = [
		{ field: "Action", value: "Buy" },
		{ field: "Number of lots", value: "1" },
		{ field: "Total Order Value", value: "₹ 9,37,500.00" },
		{ field: "Order Type", value: "Market" },
		{ field: "Product Type", value: "FNO Plus- NRML" }
	];

	function onBuySellTagSelect(tagName: EBuyOrSell) {
		console.log(tagName);
	}

	function onRadioSelect(val: string | number) {
		console.log(val);
	}

	function onInputChange(val: string) {
		console.log(val);
	}

	function onInputBlur(val: indexer) {
		console.log(val);
	}

	function onTotalPeriodChange(val: number) {
		console.log(val);
	}

	function onButtonClick(e: React.MouseEvent<HTMLButtonElement, MouseEvent>) {
		console.log(e);
	}

	return (
		<div className="op_sample_components">
			<h1 className="sample_heading1">Asset Classes</h1>
			<h2 className="sample_heading">Buy/Sell Tags:</h2>
			<OpBuySellTag onSelect={onBuySellTagSelect} />

			<br />
			<hr />
			<br />

			<h2 className="sample_heading">Radio Buttons:</h2>
			<ul>
				{sampleList.map(item => (
					<li key={item.value} className="list_Item" onClick={() => onRadioSelect(item.value)}>
						<RadioButton
							list={{
								value: item.value,
								display: item.display
							}}
							name={"cvtPosition"}
							selected={selectedRadio}
							onChange={() => setSelectedRadio(item.value)}
						/>
					</li>
				))}
			</ul>

			<br />
			<hr />
			<br />

			<h2 className="sample_heading">Fund transfer:</h2>
			{!DeviceContext().isMobile && (
				<div className="op_fund_type_desk">
					<span>
						<span className="label ib">Fund Type</span>
						<div className="ib">
							<NavigationTag tagList={tagList} defaultValue="regular" onSelect={onRadioSelect} />
						</div>
					</span>
					<OpExplainButton tooltipData={tooltipData} />
				</div>
			)}

			<br />
			<hr />
			<br />

			{/* These input boxes have max-width=280px in desktop, if small size is needed, then wrap in a div of small size */}
			<h2 className="sample_heading">Input field (grey help text):</h2>
			<InputField
				defaultValue="Hello"
				onChange={onInputChange}
				onBlur={onInputBlur}
				placeholder="Enter Amount"
				prefix="prefix"
				suffix="suffix"
				helpText={dummyText.split(".")[0]}
			/>
			<br />
			<h2 className="sample_heading">Input field (blue help text):</h2>
			<InputField
				onChange={onInputChange}
				onBlur={onInputBlur}
				placeholder="Enter Amount"
				prefix="prefix"
				helpText={dummyText.split(".")[0]}
				helpTextColor="blue"
			/>
			<br />
			<h2 className="sample_heading">Input field (error text):</h2>
			<InputField
				onChange={onInputChange}
				onBlur={onInputBlur}
				placeholder="Enter Amount"
				suffix="suffix"
				errorText={dummyText.split(".")[0]}
			/>
			<br />
			<h2 className="sample_heading">Input field (error and help text):</h2>
			<InputField
				onChange={onInputChange}
				onBlur={onInputBlur}
				placeholder="Enter Amount"
				errorText={dummyText.split(".")[0]}
				helpText={dummyText.split(".")[1].split("!")[0]}
			/>
			<br />
			<h2 className="sample_heading">Input num field - comma separated on blur - (grey help text):</h2>
			<OpInputNumField
				onChange={onInputChange}
				onBlur={onInputBlur}
				placeholder="Enter Amount"
				prefix="prefix"
				suffix="suffix"
				helpText={dummyText.split(".")[0]}
			/>

			<br />
			<hr />
			<br />

			<h2 className="sample_heading">Mandate Dropdown + Mandate button</h2>
			<OpMandateDropdown
				onOptionSelect={console.log}
				dropdownList={[
					{ bankName: "ICICI Bank", transactionLimit: "₹ 2,00,000", mandateId: 1275459, acc: "7897 3457 8766 7878", isApproved: true },
					{ bankName: "ICICI Bank", transactionLimit: "₹ 2,00,000", mandateId: 2275459, acc: "7897 3457 8766 7878", isApproved: true },
					{ bankName: "ICICI Bank", transactionLimit: "₹ 2,00,000", mandateId: 3275459, acc: "7897 3457 8766 7878", isApproved: false },
					{ bankName: "ICICI Bank", transactionLimit: "₹ 2,00,000", mandateId: 4275459, acc: "7897 3457 8766 7878", isApproved: true },
					{ bankName: "ICICI Bank", transactionLimit: "₹ 2,00,000", mandateId: 5275459, acc: "7897 3457 8766 7878", isApproved: true },
					{ bankName: "ICICI Bank", transactionLimit: "₹ 2,00,000", mandateId: 6275459, acc: "7897 3457 8766 7878", isApproved: false },
					{ bankName: "ICICI Bank", transactionLimit: "₹ 2,00,000", mandateId: 7275459, acc: "7897 3457 8766 7878", isApproved: true },
					{ bankName: "ICICI Bank", transactionLimit: "₹ 2,00,000", mandateId: 8275459, acc: "7897 3457 8766 7878", isApproved: true },
					{ bankName: "ICICI Bank", transactionLimit: "₹ 2,00,000", mandateId: 9275459, acc: "7897 3457 8766 7878", isApproved: false },
					{ bankName: "ICICI Bank", transactionLimit: "₹ 2,00,000", mandateId: 4375459, acc: "7897 3457 8766 7878", isApproved: true },
					{ bankName: "ICICI Bank", transactionLimit: "₹ 2,00,000", mandateId: 2475459, acc: "7897 3457 8766 7878", isApproved: true },
					{ bankName: "ICICI Bank", transactionLimit: "₹ 2,00,000", mandateId: 3575459, acc: "7897 3457 8766 7878", isApproved: false },
					{ bankName: "ICICI Bank", transactionLimit: "₹ 2,00,000", mandateId: 4675459, acc: "7897 3457 8766 7878", isApproved: true },
					{ bankName: "ICICI Bank", transactionLimit: "₹ 2,00,000", mandateId: 2775459, acc: "7897 3457 8766 7878", isApproved: true },
					{ bankName: "ICICI Bank", transactionLimit: "₹ 2,00,000", mandateId: 3875459, acc: "7897 3457 8766 7878", isApproved: false },
					{ bankName: "ICICI Bank", transactionLimit: "₹ 2,00,000", mandateId: 4975459, acc: "7897 3457 8766 7878", isApproved: true },
					{ bankName: "ICICI Bank", transactionLimit: "₹ 2,00,000", mandateId: 2075459, acc: "7897 3457 8766 7878", isApproved: true },
					{ bankName: "ICICI Bank", transactionLimit: "₹ 2,00,000", mandateId: 3285459, acc: "7897 3457 8766 7878", isApproved: false },
					{ bankName: "ICICI Bank", transactionLimit: "₹ 2,00,000", mandateId: 4295459, acc: "7897 3457 8766 7878", isApproved: true }
				]}
			/>

			<br />
			<hr />
			<br />

			<h2 className="sample_heading">Order placement dropdown</h2>
			<OpDropdown dropdownOptions={sampleList} onOptionSelect={console.log} />

			<br />
			<hr />
			<br />

			<h2 className="sample_heading">Calender (css not done yet)</h2>
			<OpCalender onDateSelect={console.log} />

			<br />
			<hr />
			<br />

			<h2 className="sample_heading">Generate mandate</h2>
			<OpGenerateMandate {...opGenerateMandateProps} />

			<br />
			<hr />
			<br />

			<h2 className="sample_heading">Insufficient funds error:</h2>
			<OpInsufficientFunds currentValue="₹1,000" orderValue="₹10,000" radioButtonList={sampleList} onProceed={console.log} isSip />

			<br />
			<hr />
			<br />

			<h2 className="sample_heading">Order Status screen:</h2>
			<OpOrderStatus ordNo="183623732823" ordStsUrl="#" posUrl="#" placeOrdUrl="#" />

			<br />
			<hr />
			<br />

			<h2 className="sample_heading">Order confirmation screens:</h2>
			<OpConfirmation
				buyOrSell={EBuyOrSell.BUY}
				title="SUNPHRMA"
				subtitle="Sun Pharmaceutical Industries Ltd. lorem iopds"
				exchange="NSE"
				contentArr={contentForConfirmationScreen}
				onCancel={onButtonClick}
				onConfirm={onButtonClick}
			/>

			<br />
			<hr />
			<br />

			<OpConfirmation
				buyOrSell={EBuyOrSell.BUY}
				title="SUNPHRMA"
				subtitle="HDFC Top 100 Balanced Arbitrage Fund"
				contentArr={contentForConfirmationScreen1}
				onCancel={onButtonClick}
				onConfirm={onButtonClick}
			/>

			<br />
			<hr />
			<br />

			<OpConfirmation
				buyOrSell={EBuyOrSell.BUY}
				title="SUNPHRMA"
				subtitle="20 FEB’20 FUT"
				isSubtitlebig
				contentArr={contentForConfirmationScreen2}
				note={
					<div>
						<p className="note_text">Note</p>
						<ul className="note_ul">
							<li>Orders will be placed on nearest available business day on or after the SIP date</li>
							<li>
								All E-SIP orders will be placed under “Delivery Plus - NRML” product type. On E-SIP due date, in case you do not have
								sufficient cash in your account equivalent to the order requirement, system will consider total limits available for order
								placement including stocks collateral. The debit (if any) post the E-SIP order placement will have to be cleared within 5
								days post the settlement day to avoid liquidation
							</li>
						</ul>
					</div>
				}
				onCancel={onButtonClick}
				onConfirm={onButtonClick}
			/>

			<br />
			<hr />
			<br />

			<h2 className="sample_heading">Total Period input:</h2>
			<OpTotalPeriod
				onChange={onTotalPeriodChange}
				// errorText={dummyText.split(".")[0]}
				label="Total Period"
				id="sample"
				helpTextGrey="Days"
				helpTextBlue="(Ends on: 27 Sept 2020)"
				min={0}
				max={10}
				onBlur={onInputBlur}
			/>

			<br />
			<hr />
			<br />
		</div>
	);
};

export default OpSampleComponents;
